import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import matchReducer from './matchSlice';
import calendarReducer from './calendarSlice';
import calendarDataSelfReducer from './calendarDataSelfSlice';
import userReducer from './userSlice';
import ratingsReducer from './ratingsSlice';
import matchesReducer from './matchesSlice';
import chatsReducer from './chatsSlice';
import profilesReducer from './profilesSlice';
import loadingReducer from './loadingSlice';
import uploadsReducer from './uploadsSlice';
import calendarSharesReducer from './calendarSharesSlice';
import ovulationTestsReducer from './ovulationTestsSlice';
export { setPage, setStoreCategory, setShowMenu, setShowSettings, setSettingsTab, setShowShareCalendar, setImageViewer, setDayMenuDate, setDayMenuOtherUserDate, setProfileViewing, setEventData, setEventWindowData, setDesktopMenu, setHelpMenu, setTestViewer, setImagePredictionMenu, setDarkMode } from './uiSlice';
export { matchPass, matchLike, matchUndo, matchReset } from './matchSlice';
export { setVisibleMonths, setMonthInView, setCalendarData, setOtherUsersCalendarData } from './calendarSlice';
export { setCalendarDataSelf, setCalendarDataSelfProcessed, updateCalendarDataSelfDate } from './calendarDataSelfSlice';
export { setAuthUser, setSession, setProfile, setProfileLoading, loadProfileFromCache, incrementProfileUpdating, decrementProfileUpdating, setProfileUpdatingError, addUploadInProgress, removeUploadInProgress } from './userSlice';
export { setSelfTests, addOrUpdateSelfTest, setOtherUsersTests, updateOtherUsersTest, setListenerUserIds, loadSelfTestsFromCache, loadOtherUsersTestsFromCache } from './ovulationTestsSlice';
export { setConnectionStatus, incrementOperation, decrementOperation, setOperationError, clearOperationError } from './loadingSlice';
export { setRatingsCache, setRatingsLoading, addRating, updateRating, setUserIdsToLoad } from './ratingsSlice';
export { setMatchList, appendMatches, replaceMatches, removeMatch, clearMatches, pushAction, popAction, clearActionHistory, refreshMatches, addRecentlyActedId, clearRecentlyActedIds, setExhausted, resetExhausted, setLoading } from './matchesSlice';
export { setChats, addChat, setLoading as setChatsLoading, setUnreadCount } from './chatsSlice';
export { setProfiles, setOtherUserProfile } from './profilesSlice';
export { addUpload, updateUpload, updateAttachment, removeUpload } from './uploadsSlice';
export { setSharesLoaded, setSharesLoading, setOwnedShares, setReceivedShares, upsertOwnedShare, upsertReceivedShare, removeOwnedShare, removeReceivedShare, clearShares } from './calendarSharesSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    match: matchReducer,
    calendar: calendarReducer,
    calendarDataSelf: calendarDataSelfReducer,
    user: userReducer,
    ratings: ratingsReducer,
    matches: matchesReducer,
    chats: chatsReducer,
    profiles: profilesReducer,
    loading: loadingReducer,
    uploads: uploadsReducer,
    calendarShares: calendarSharesReducer,
    ovulationTests: ovulationTestsReducer,
  },
});
